/* GearFrost — collection-scoped search. gf-collection-search.liquid puts the collection's search scope
 * (e.g. product_type:"17 Inch Backpack" or tag:"galaxy") in data-gf-scope on the form. On submit we
 * append it to the query so /search returns only that collection's products (and still scales to the
 * whole collection via Shopify's search index). When no scope is set (complex/mixed collections) the
 * form has no data-gf-scope and search stays store-wide. */
(function () {
  function init(form) {
    var scope = (form.getAttribute('data-gf-scope') || '').trim();
    var input = form.querySelector('input[name="q"]');
    if (!scope || !input || form.dataset.gfBound) return;
    form.dataset.gfBound = '1';
    form.addEventListener('submit', function () {
      var term = (input.value || '').trim();
      // Don't double-append if the scope is already in the query.
      if (term.indexOf(scope) === -1) {
        input.value = (term + ' ' + scope).trim();
      }
    });
  }
  function ready() {
    var forms = document.querySelectorAll('form[data-gf-scope]');
    for (var i = 0; i < forms.length; i += 1) init(forms[i]);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
  // Re-bind when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', ready);
})();
